import useFetch from "./useFetch";

const useAccount = () => {
  const endpointPath = `account`;
  return useFetch(endpointPath);
};

export default useAccount;
